<template>
    <div>
        <div class="cstm-tab-holder">
            <div
                class="cstm-unique-tab flex mb-4"
            >
                <div style="width: calc(100% - 105px)" class="flex flex-wrap">
                    <div
                        class="tab-name"
                        :class="{ activeTab: template }"
                        @click="tab('template')"
                    >
                        Template
                    </div>
                    <div
                        class="tab-name"
                        :class="{ activeTab: exam }"
                        @click="tab('exam')"
                    >
                        Exams
                    </div>
                </div>
            </div>
            <div v-if="template">
              <Template />
            </div>

            <div v-if="exam">
              <CourseWork />
            </div>
        </div>
    </div>
</template>

<script>
import Template from './Template/index.vue'
import CourseWork from './Exams/index.vue'

export default {
  name: 'Exam',
  components: {
    Template,
    CourseWork
  },
  data () {
    return {
      template: true,
      exam: false      
    }
  },
  mounted() {
    this.tab(this.$route.hash.substring(1))
  },
  methods: {
    tab (type) {
      if (type === 'template') {
        this.template = true
        this.exam = false
      } else if (type === 'exam') {
        this.template = false
        this.exam = true
      }
    }
  }
}
</script>